import { render, staticRenderFns } from "./AdditionalPermissionList.vue?vue&type=template&id=76f1e97f"
import script from "./AdditionalPermissionList.vue?vue&type=script&lang=js"
export * from "./AdditionalPermissionList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports